import React from 'react'
import { Message } from 'semantic-ui-react'
import { useFileDrop } from '../../../FileDrop/FileDrop'

export const DropNotification = () => {
  const { isActive } = useFileDrop()

  if (!isActive) return null

  return (
    <Message color="blue">
      <Message.Content>Drop files</Message.Content>
    </Message>
  )
}
